<template>
    <el-dialog
            title="按月分摊"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            center
            custom-class="medium-dialog">
        <el-col :span="24">
            <el-form ref="form1" >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="类别"  :label-width="formLabelWidth" >
                    {{feeRow.categoryname}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="总额"  :label-width="formLabelWidth" >
                   {{feeRow.feemoney}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="日期"  :label-width="formLabelWidth" >
                    {{feeRow.feedate.substr(0, 10) }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-for="(offset,index) in fentanDetailjson" :key="index">
                <el-col :span="8">
                  <el-form-item label="月份"  :label-width="formLabelWidth" >
                    <el-date-picker v-model="offset.adddate" type="month" placeholder="选择月" style="width: 140px"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="金额"  :label-width="formLabelWidth" >
                    <el-input-number v-model="offset.fentanmoney" auto-complete="off" :controls="false" style="width: 140px"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
            <el-button type="primary" icon="el-icon-plus" circle size="small" v-if="index==fentanDetailjson.length-1 " @click.prevent="addOffset()"  round></el-button>
            <el-button type="danger" icon="el-icon-delete" circle size="small"  v-if="index>0" @click.prevent="removeOffset(offset,index)" round></el-button>
                  <el-button type="success" icon="el-icon-plus"  size="small" v-if="index==0" @click.prevent="addAutoOffset()" round>快速拆分</el-button>
                </el-col>
              </el-row>
            </el-form>
        </el-col>
        <span slot="footer" class="dialog-footer" >
      <el-button  type="success" @click="clearData()" v-if="showft" :loading="loading">取消分摊</el-button>
      <el-button  type="primary" @click="saveData()" :loading="loading">保存</el-button>
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
    </span>
      <el-dialog title="快速拆分" :visible.sync="dialogChild" :append-to-body="true" center custom-class="mini-dialog">
        <el-col :span="24">
          <el-form ref="form1" >
            <el-row >
              <el-col :span="24">
                <el-form-item label="开始月份"  :label-width="formLabelWidth" >
                  <el-date-picker v-model="autosplit.month" type="month" placeholder="选择月" style="width: 240px;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="几个月"  :label-width="formLabelWidth" >
                  <el-input-number v-model="autosplit.number" auto-complete="off" :precision="0" :controls="false" style="width: 240px"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <span slot="footer" class="dialog-footer" >
      <el-button  type="primary" @click="splitData()">确认</el-button>
      <el-button @click="dialogChild = false">关 闭</el-button>
    </span>
      </el-dialog>
    </el-dialog>
</template>
<script>
    import {savefentanData, fentanDetail} from "@/api/pay/paydetail";

    export default {
      name: "Paymentsfentan",
      data() {
        return {
          submoney: 0,
          showft:false,
          dialogChild:false,
          loading: false,
          feeRow: {unitguid: '', feemoney: 0, categoryname: '', feedate: '', payguid: ''},
          formLabelWidth: '80px',
          dialogFormVisible: false,
          fentanDetailjson: [],
          autosplit: {
            month: '',
            number: undefined,
          }
        };
      },
      methods: {
        addAutoOffset() {
          this.dialogChild = true;
          this.autosplit = {
            month: '',
            number: undefined,
          }
        },
        splitData() {
          if (!this.autosplit.month) {
            this.$message({
              message: '开始月份必选！',
              type: "error"
            });
            return;
          }
          if (!this.autosplit.number > 0) {
            this.$message({
              message: '拆分的月份数必填！',
              type: "error"
            });
            return;
          }
          this.fentanDetailjson = [];
          var num = parseInt(this.autosplit.number);
          var Totalmoney = parseFloat(this.feeRow.feemoney);
          var perMoney = parseFloat((parseFloat(Totalmoney) / parseFloat(num)).toFixed(2));
          for (var i = 0; i < num; i++) {
            if (i == num - 1) {
              perMoney = Totalmoney;
            } else {
              Totalmoney = Totalmoney - perMoney;
            }
            this.fentanDetailjson.push({
              adddate: this.addMonth(this.autosplit.month,i),
              fentanmoney: perMoney.toFixed(2),
            });
          }
          this.dialogChild = false;
          this.subMoney();
        },
        addMonth(dates,index){
          if(index==0) return dates;
          const newDate = new Date(dates);
          newDate.setMonth(newDate.getMonth() + index);
          return newDate;
        },
        editPage(row) {
          this.feeRow = row;
          this.showft=false;
          this.fentanDetailjson = [];
          this.dialogFormVisible = true;
          fentanDetail({fentanguid: this.feeRow.unitguid}).then(response => {
            if (response.data.code == 0) {
              this.fentanDetailjson = response.data.obj;
              this.showft=this.fentanDetailjson.length>0;
              this.subMoney();
            }
          })
        },
        clearData(){
          this.fentanDetailjson=[];
          this.saveData();
        },
        saveData() {
          if(this.fentanDetailjson.length>0) {
            for (let i in this.fentanDetailjson) {
              if (!this.fentanDetailjson[i].adddate) {
                this.$message({
                  message: '月份必选！',
                  type: "error"
                });
                return;
              }
              var money = this.fentanDetailjson[i].fentanmoney;
              if (!money) {
                this.$message({
                  message: '金额必填！',
                  type: "error"
                });
                return;
              }
            }
            this.subMoney();
            if (this.submoney.toFixed(2) != this.feeRow.feemoney.toFixed(2)) {
              this.$message({
                message: '还剩！' + (this.submoney - this.feeRow.feemoney).toFixed(2) + '未分配！',
                type: "error"
              });
              return;
            }
          }
          this.loading = true;
          savefentanData({
            fentanguid: this.feeRow.unitguid,
            payguid: this.feeRow.payguid,
            details: JSON.stringify(this.fentanDetailjson)
          }).then(respnse=>{
            if(respnse.data.code==0) {
              this.$message({
                message: "保存成功！",
                type: "success"
              });
              this.dialogFormVisible = false;
              this.feeRow.isfentan = this.fentanDetailjson.length == 0 ? 0 : 9;
            }else{
              this.$message({
                message: respnse.data.msg,
                type: "error"
              });
            }
            this.loading = false;
          });
        },
        removeOffset(offset, index) {
          this.fentanDetailjson.splice(index, 1);
          this.subMoney();
        },
        //添加分摊信息
        addOffset() {
          this.subMoney();
          this.fentanDetailjson.push({
            adddate: "",
            fentanmoney: (this.feeRow.feemoney - this.submoney).toFixed(2),
          });
        },
        subMoney() {
          this.submoney = 0;
          for (let i in this.fentanDetailjson) {
            var money = this.fentanDetailjson[i].fentanmoney;
            if (money) {
              this.submoney += money;
            }
          }
          if(this.fentanDetailjson.length==0){
            this.fentanDetailjson.push({
              adddate: "",
              fentanmoney: 0,
            });
          }
        }
      },
      components: {
      },
      mounted() {
      }
    };
</script>



// WEBPACK FOOTER //
// src/components/oa/payform/Paymentsfentan.vue